import React, { useState, useEffect } from "react";
import searchIcon from "../Assets/img/Blogs/search.png";
import style from "../Assets/css/blogs.module.css";

export default function AggregationPages() {
	const [singleAggregation, setSingleAggregation] = useState(false);
	const [singleAggregationValue, setSingleAggregationValue] = useState({});
	const [tableAggregation, setTableAggregation] = useState(false);
	const [tableAggregationValue, setTableAggregationValue] = useState({
		value: [],
	});
	const [headerTable, setTableHeader] = useState([]);

	const [searchTerm, setSearchTerm] = useState("");
	const [searchTermTable, setSearchTermTable] = useState("");
	const [searchTermSingle, setSearchTermSingle] = useState("");
	const [search, setSearch] = useState(false);
	var [searchQuery, setSearchQuery] = useState([]);
	var [searchPart, setSearchPart] = useState([]);
	var [searchTopic, setSearchTopic] = useState([]);

	let searchObject = {
		CLPRegistrations: "CLP registrations",
		totalAttendees: "Number of attendees",
		formsFilled: "People who filled the form",
		averageInterest: "Average Interest Rating",
		thirdYrAttended: "Attendees from third year",
		fourthYrAttended: "Attendees from fourth year",
		CLPAttended: "Attended by CLP registrations",
	};

	let searchObjectTest = {
		"CLP registrations": "CLPRegistrations",
		"Number of attendees": "totalAttendees",
		"People who filled the form": "formsFilled",
		"Average Interest Rating": "averageInterest",
		"Attendees from third year": "thirdYrAttended",
		"Attendees from fourth year": "fourthYrAttended:",
		"Attended by CLP registrations": "CLPAttended",
		"Total Registrations": "totalRegistration",
	};

	let searchObjectTable = {
		"Area of Interest and people attended": "interestArea_peopleAttended",
		"Current City and CLPRegistrations": "currentCity_CLPRegistrations",
		"Current City and people attended": "currentCity_peopleAttended",
		"college name and people attended": "collegeName_peopleAttended",
		"Graduation Degree and people attended": "degree_peopleAttended",
		"Year of study and CLPAttendees": "currentYear_CLPAttendees",
		"Forms filled": "formsFilled",
	};

	useEffect(() => {
		if (singleAggregation) {
			setSearchTopic(
				Object.keys(searchObjectTest).filter((obj) =>
					obj.toLowerCase().includes(searchTermSingle.toLowerCase())
				)
			);
			if (
				searchTopic.length > 0 &&
				searchObjectTest[searchTopic[0]] !== undefined
			) {
				fetch(
					`https://api.cantileverlabs.com/singleAggregation?aggregate=${
						searchObjectTest[searchTopic[0]]
					}`
				)
					.then((res) => res.json())
					.then((data) => setSearchPart(data))
					.catch((err) => console.log(err));
			}
		}
	}, [searchTermSingle]);

	useEffect(() => {
		if (tableAggregation) {
			setSearchTopic(
				Object.keys(searchObjectTable).filter((obj) =>
					obj.toLowerCase().includes(searchTermTable.toLowerCase())
				)
			);
			console.log(searchObjectTable[searchTopic[0]]);
			if (
				searchTopic.length > 0 &&
				searchObjectTable[searchTopic[0]] !== undefined
			) {
				fetch(
					`https://api.cantileverlabs.com/tableAggregation?aggregate=${
						searchObjectTable[searchTopic[0]]
					}`
				)
					.then((res) => res.json())
					.then((data) => setTableAggregationValue(data[0]))
					.catch((err) => console.log(err));
			}
			console.log(searchPart);
			console.log(tableAggregation, singleAggregation);
		}
	}, [searchTermTable]);

	const camelCharacter = (string) => {
		let arr = string.split("");
		let result = "";
		for (let i = 0; i < arr.length; i++) {
			if (i === 0) {
				result += arr[i].toUpperCase();
			} else if (arr[i] === arr[i].toUpperCase()) {
				result += ` ${arr[i]}`;
			} else {
				result += arr[i];
			}
		}
		return result;
	};

	const radioFunctionSingle = (e) => {
		setSingleAggregation(true);
		setTableAggregation(false);
	};

	const radioFunctionTable = (e) => {
		setSingleAggregation(false);
		setTableAggregation(true);
	};

	const queryChange = async (e, order) => {
		const API_ENDPOINT = "https://api.cantileverlabs.com/";
		let aggregate;
		order = order ? order : "1";
		let orderState = document.getElementById("sortingOrder")
			? document.getElementById("sortingOrder").value
			: false;
		if (orderState === "ascending") {
			order = "1";
		}
		if (orderState === "descending") {
			order = "-1";
		}

		if (singleAggregation) {
			setTableAggregationValue({ value: [] });
			aggregate = document.getElementById("singleQueries").value;
			fetch(`${API_ENDPOINT}singleAggregation?aggregate=${aggregate}`)
				.then((res) => res.json())
				.then((data) => setSingleAggregationValue(data))
				.catch((err) => console.log(err));
		}

		if (tableAggregation) {
			await setSingleAggregationValue({});
			aggregate = document.getElementById("tableQueries").value;
			fetch(
				`${API_ENDPOINT}tableAggregation?aggregate=${aggregate}&order=${order}`
			)
				.then((res) => res.json())
				.then(([data]) => setTableAggregationValue(data))
				.catch((err) => console.log(err));
		}
		console.log(tableAggregationValue);
	};

	function setOrder() {
		let order = document.getElementById("sortingOrder").value;
		if (order === "ascending") {
			queryChange("e", "1");
			return;
		} else {
			queryChange("e", "-1");
		}
	}

	useEffect(() => {
		if (tableAggregation) {
			tableAggregationValue.value.map((obj, pos) => {
				let arr = Object.entries(obj);
				let header_array = [];
				if (pos === 1) {
					for (let i = 0; i < arr.length; i++) {
						header_array.push(camelCharacter(arr[i][0]));
					}
					setTableHeader(header_array);
				}
			});
		}
	}, [tableAggregationValue]);

	return (
		<div>
			<div>
				<input
					type="radio"
					id="single_aggregation"
					name="aggregation_type"
					onChange={radioFunctionSingle}
				/>
				<label for="single_aggregation">Single Aggregation Data</label>
			</div>
			<div>
				<input
					type="radio"
					id="table_aggregation"
					name="aggregation_type"
					onChange={radioFunctionTable}
				/>
				<label for="table_aggregation">Table Aggregation Data</label>
			</div>
			<div>
				{singleAggregation && (
					<div style={{ display: "flex" }}>
						<select name="singleQueries" id="singleQueries">
							<option value="totalRegistration">
								Total Registrations
							</option>
							<option value="CLPRegistrations">
								CLP registrations
							</option>
							<option value="totalAttendees">
								Number of attendees
							</option>
							<option value="formsFilled">
								People who filled the form
							</option>
							<option value="averageInterest">
								Average Interest Rating
							</option>
							<option value="thirdYrAttended">
								Attendees from third year
							</option>
							<option value="fourthYrAttended">
								Attendees from fourth year
							</option>
							<option value="CLPAttended">
								Attended by CLP registrations
							</option>
						</select>
						<span
							style={{
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
								position: "relative",
								left: "10%",
							}}
						>
							<img
								style={{ paddingRight: "1%" }}
								src={searchIcon}
								alt=""
							/>
							<input
								className={style.searchPlace}
								style={{
									boxSizing: "border-box",
									// border: "3px solid #ccc",
									border: "none",
									webkitTransition: "0.5s",
									transition: "0.5s",
									outline: "none",
									fontFamily: "Poppins-Regular",
									fontSize: "20px",
								}}
								type="text"
								value={searchTermSingle}
								onChange={(e) => {
									setSearchTermSingle(e.target.value);
									//   queryFilterChange(e);
									console.log(searchTerm);
								}}
								placeholder="Search..."
							/>
						</span>
					</div>
				)}
				{tableAggregation && (
					<div style={{ display: "flex" }}>
						<select name="tableQueries" id="tableQueries">
							<option value="interestArea_peopleAttended">
								Area of Interest and people attended
							</option>
							<option value="formsFilled">Forms filled</option>
							<option value="currentCity_CLPRegistrations">
								Current City and CLPRegistrations
							</option>
							<option value="currentCity_peopleAttended">
								Current City and people attended
							</option>
							<option value="collegeName_peopleAttended">
								college name and people attended
							</option>
							<option value="degree_peopleAttended">
								Graduation Degree and people attended
							</option>
							<option value="currentYear_CLPAttendees">
								Year of study and CLPAttendees
							</option>
						</select>
						<span
							style={{
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
								position: "relative",
								left: "10%",
							}}
						>
							<img
								style={{ paddingRight: "1%" }}
								src={searchIcon}
								alt=""
							/>
							<input
								className={style.searchPlace}
								style={{
									boxSizing: "border-box",
									// border: "3px solid #ccc",
									border: "none",
									webkitTransition: "0.5s",
									transition: "0.5s",
									outline: "none",
									fontFamily: "Poppins-Regular",
									fontSize: "20px",
								}}
								type="text"
								value={searchTermTable}
								onChange={(e) => {
									setSearchTermTable(e.target.value);
									//   queryFilterChange(e);
								}}
								placeholder="Search..."
							/>
						</span>
					</div>
				)}
				<button onClick={queryChange}>Get Data</button>
				<br />
				<br />
			</div>

			{singleAggregation &&
				searchTermSingle !== "" &&
				searchTopic.length > 0 && (
					<div>
						<h2>{searchTopic[0]}</h2>
						<b>{searchPart.query}</b>
						<span>: {searchPart.value}</span>
					</div>
				)}
			{singleAggregation &&
				searchTermSingle &&
				searchTopic.length === 0 && (
					<h1 style={{ textAlign: "center", paddingTop: "5%" }}>
						No Related Data with the word {searchTerm} found{" "}
					</h1>
				)}
			{tableAggregation &&
				searchTermTable &&
				searchTopic.length === 0 && (
					<h1 style={{ textAlign: "center", paddingTop: "5%" }}>
						No Related Data with the word {searchTerm} found{" "}
					</h1>
				)}
			{singleAggregation &&
				searchTermSingle === "" &&
				singleAggregationValue.value && (
					<div>
						<b>{singleAggregationValue.query}</b>
						<span>: {singleAggregationValue.value}</span>
					</div>
				)}

			{/*ddddddddd  */}
			{tableAggregation &&
				searchTermTable !== "" &&
				searchTopic.length > 0 && (
					<>
						<h2>{searchTopic[0]}</h2>
						<select
							name="sortingOrder"
							id="sortingOrder"
							onChange={setOrder}
						>
							<option value="ascending">Ascending</option>
							<option value="descending">Descending</option>
						</select>
						<table
							style={{ border: "1px solid #000", width: "50%" }}
							id="dataTable"
						>
							<tr>
								{headerTable.map((val) => {
									return (
										<th
											style={{
												border: "1px solid #000",
												padding: "5px",
											}}
										>
											{val}
										</th>
									);
								})}
							</tr>
							{tableAggregationValue.value.map((res, pos) => {
								let arr = Object.entries(res);
								let headers_array = [];
								if (pos === 1) {
									for (let i = 0; i < arr.length; i++) {
										headers_array.push(
											camelCharacter(arr[i][0])
										);
									}
								}
								return (
									<tbody key={pos}>
										<tr>
											{arr.map(([key, val]) => {
												return (
													<td
														style={{
															border: "1px solid #000",
															padding: "5px",
														}}
													>
														{val}
													</td>
												);
											})}
										</tr>
									</tbody>
								);
							})}
						</table>
					</>
				)}
			{tableAggregation &&
				searchTermTable === "" &&
				tableAggregationValue.query && (
					<>
						<select
							name="sortingOrder"
							id="sortingOrder"
							onChange={setOrder}
						>
							<option value="ascending">Ascending</option>
							<option value="descending">Descending</option>
						</select>
						<table
							style={{ border: "1px solid #000", width: "50%" }}
							id="dataTable"
						>
							<tr>
								{headerTable.map((val) => {
									return (
										<th
											style={{
												border: "1px solid #000",
												padding: "5px",
											}}
										>
											{val}
										</th>
									);
								})}
							</tr>
							{tableAggregationValue.value.map((res, pos) => {
								let arr = Object.entries(res);
								let headers_array = [];
								if (pos === 1) {
									for (let i = 0; i < arr.length; i++) {
										headers_array.push(
											camelCharacter(arr[i][0])
										);
									}
								}
								return (
									<tbody key={pos}>
										<tr>
											{arr.map(([key, val]) => {
												return (
													<td
														style={{
															border: "1px solid #000",
															padding: "5px",
														}}
													>
														{val}
													</td>
												);
											})}
										</tr>
									</tbody>
								);
							})}
						</table>
					</>
				)}
		</div>
	);
}
